import { generateIconComponent } from './icons.utils';

export const ChevronLeftSolidIcon = generateIconComponent({
    name: 'ChevronLeftSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M17.1212 0.32204L18.678 1.87884C19.1073 2.30823 19.1073 3.00626 18.678 3.43565L10.1126 11.9992L18.678 20.5627C19.1073 20.9943 19.1073 21.6901 18.678 22.1195L17.1212 23.6763C16.6919 24.1079 15.9939 24.1079 15.5645 23.6763L5.44235 13.556C5.03059 13.1442 4.79719 12.5827 4.79719 11.9992C4.79719 11.4156 5.03059 10.8563 5.44235 10.4424L15.5645 0.32204C15.9939 -0.107347 16.6919 -0.107347 17.1212 0.32204Z" />
    ),
});
